import React, { useRef, useState, useEffect } from 'react';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import {
  HeroTextPairing,
  RegistryHeroTextColumn,
  StyledSection,
  MainBackgroundImage,
  GradientWrap,
} from '@sections/cash-fund-registry/RegistryHeroSection/RegistryHeroSection.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { defaultBase64Placeholder } from '@components/CloudImage';
import { registryPageData } from '@data-ts/pages/cash-fund-registry';
import ReactHtmlParser from 'react-html-parser';

const registryHeroData = registryPageData.hero;

interface RegistryHeroSectionProps {}

export const RegistryHeroSection: React.FC<RegistryHeroSectionProps> = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  let [isScrolledIntoView, setScrolledIntoView] = useState(true);
  const IMAGE_HEIGHT = 975;
  const IMAGE_WIDTH = 1536;
  const [heroImageHeight, setHeroImageHeight] = useState(960);
  useEffect(() => {
    const handleResize = () => {
      if (sectionRef.current) {
        setHeroImageHeight((IMAGE_HEIGHT / IMAGE_WIDTH) * sectionRef.current?.clientWidth);
      }
    };
    if (sectionRef.current) {
      setHeroImageHeight((IMAGE_HEIGHT / IMAGE_WIDTH) * sectionRef.current?.clientWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [sectionRef]);

  return (
    <StyledSection as="section" ref={sectionRef} id="Registry_Hero" paddingTop={[7, 0]} height={heroImageHeight}>
      <MainBackgroundImage
        backgroundImage={isScrolledIntoView ? 'cash-fund/hero.jpg' : defaultBase64Placeholder}
        backgroundImageMobile={isScrolledIntoView ? 'cash-fund/hero-mobile-v2.jpg' : defaultBase64Placeholder}
        height={heroImageHeight}
      >
        <GradientWrap />
        <LazyLoadWrapper beforeLoad={() => setScrolledIntoView(true)}>
          <div />
        </LazyLoadWrapper>
        <RegistryHeroTextColumn verticalAlign="center">
          <Columns.Column width={6} mobile={12}>
            <Flex flexDirection={'column'} alignItems={['left', 'left']} paddingRight={[0, 10]}>
              <HeroTextPairing
                title={ReactHtmlParser(registryHeroData.title)}
                titleVariant="hed56"
                titleColor="neutra6"
                titleTagName="h1"
                bodyTagName="p"
                body={registryHeroData.content}
                bodyVariant="dek20"
                bodyColor="neutra5"
                marginTop={[13, 0]}
                alignment={'left'}
              />
              <Box style={{ textAlign: 'left', marginTop: '20px' }}>
                <GetStartedButton id="honeymoonRegistryHeroGetStartedBtn" page={'registry'} variant="primary">
                  {registryPageData.getStarted}
                </GetStartedButton>
              </Box>
            </Flex>
          </Columns.Column>
        </RegistryHeroTextColumn>
      </MainBackgroundImage>
    </StyledSection>
  );
};
